import { ArrowLeftRight, BadgeCheck, ChefHat, Flame, Leaf, MessageSquare, Sparkles, X } from 'lucide-react';

// Labels mirror the Android edit sheet (`RecipeModificationUi.kt`), so the page shows the same
// four choices and wording the customer meets in the app.
const editOptions = [
    { icon: Leaf, title: 'بدون کربوهیدرات', text: 'نسخه‌ای متناسب‌تر با هدفت بساز' },
    { icon: Flame, title: 'کاهش کالری', text: 'تعیین کن کالری تا چند درصد کمتر شود' },
    { icon: ArrowLeftRight, title: 'جایگزینی ماده اولیه', text: 'یک یا چند ماده را با گزینه‌ای تازه عوض کن' },
    { icon: MessageSquare, title: 'دلخواه', text: 'تغییری که در ذهن داری با زبان خودت بنویس' },
];

const sheetChips = ['بدون کربوهیدرات', 'کاهش کالری', 'جایگزینی ماده اولیه', 'دلخواه'];

const AppPreview = () => (
    <section id="smart-edit" className="section smart-edit-section">
        <div className="site-container smart-edit-grid">
            <div className="edit-preview" aria-label="نمونه ویرایش دستور پخت در هوش‌پز">
                <div className="edit-preview-header">
                    <span><Sparkles size={17} /> ویرایش دستور پخت</span>
                    <small>با همان اعتبار دستور پخت</small>
                </div>
                <div className="edit-preview-recipe">
                    <div className="recipe-avatar"><ChefHat size={24} /></div>
                    <div><small>دستور فعلی</small><strong>خوراک گوشت و قارچ با سیب‌زمینی</strong></div>
                </div>
                <div className="edit-chips">
                    {sheetChips.map((chip) => (
                        <span key={chip} className={chip === 'جایگزینی ماده اولیه' ? 'active' : ''}>{chip}</span>
                    ))}
                </div>
                <div className="edit-swap-box">
                    <label>موادی که حذف می‌شوند</label>
                    <div><span>گوشت قرمز <X size={12} /></span></div>
                    <label>جایگزین</label>
                    <strong>سینه مرغ</strong>
                </div>
                <div className="edit-apply">اعمال تغییر</div>
                <div className="edit-result"><BadgeCheck size={22} /><span><b>نسخه تازه آماده است: خوراک مرغ و قارچ</b><small>مراحل و مقدار مواد با تغییر جدید هماهنگ شدند.</small></span></div>
            </div>

            <div className="smart-edit-copy">
                <div className="eyebrow light"><Sparkles size={17} /> ویرایش هوشمند</div>
                <h2>دستور پخت، پایان کار نیست؛ شروع شخصی‌سازی است.</h2>
                <p>
                    نتیجه را دوست داری اما یک بخشش با تو جور نیست؟ لازم نیست از اول شروع کنی.
                    هوش‌پز نسخه قبلی را می‌شناسد و تغییر موردنظرت را روی همان دستور اعمال می‌کند.
                </p>
                <div className="edit-options">
                    {editOptions.map(({ icon: Icon, title, text }) => (
                        <div key={title}><Icon size={22} /><span><b>{title}</b><small>{text}</small></span></div>
                    ))}
                </div>
                <a href="#download" className="button button-ivory">امتحان در هوش‌پز</a>
            </div>
        </div>
    </section>
);

export default AppPreview;
